import React from "react";
import { Link } from "react-router-dom";
const Breadcrumb = ({ data }) => {

    return (
        <>

            <div className="container">
                <ul className="breadcrumb justify-content-start">
                    {data.map(({ name, url, url_path }, index) => (
                        <React.Fragment key={index}>
                            {url ? (
                                <li key={index} className="breadcrumb-item">
                                    <Link to={url} state={{ url_path: "" + url_path }}>{name}</Link>
                                </li>
                            ) : (
                                <li key={index} className="breadcrumb-item active">
                                    {name}
                                </li>
                            )}
                        </React.Fragment>
                    ))}

                </ul>
            </div>

        </>
    )
}
export default Breadcrumb;

